import * as React from "react";
import Loading from "components/Loading";
import * as styles from "./styles";

interface IProps {
  state: boolean;
  loading: boolean;
  onChange: (val: boolean) => void;
}

const Switch: React.FunctionComponent<IProps> = ({
  state,
  loading,
  onChange
}) => {
  if (loading && state) {
    return (
      <div className={`${styles.container} ${styles.active}`}>
        <Loading size="mediumsmall" color={"blue"} />
      </div>
    );
  } else if (loading && !state) {
    return (
      <div className={styles.container}>
        <Loading size="mediumsmall" color="blue" />
      </div>
    );
  } else if (!loading && state) {
    return (
      <div
        onClick={() => onChange(!state)}
        className={`${styles.container} ${styles.active}`}
      >
        <div className={styles.whiteSquare} />
      </div>
    );
  }

  return (
    <div onClick={() => onChange(!state)} className={styles.container}>
      <div className={styles.greySquare} />
    </div>
  );
};

export default Switch;
